import { ICalendarDateActive } from 'src/app/interfaces/calendar.interfaces';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DateTime } from 'luxon';
import { ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RnumbService } from 'src/app/services/rnumb.service';
import {
    formatApiDate,
    formatTime,
    formatUiDate,
    getDateKey,
    parseDateTime,
    toDateTime,
} from 'src/app/shared/date/date.utils';
import { MatDialog } from '@angular/material/dialog';

import { getNameDay, strToDate } from '../../application/global.function';
import { ITalonModal } from 'src/app/interfaces/record.interfaces';
import { Router } from '@angular/router';
import { IRnumbList } from 'src/app/interfaces/rnumb.interfaces';

import { NewTalonComponentMobile } from 'src/app/modals/new-talon-mobile/talon.component';

import { lastValueFrom } from 'rxjs';
import { DoctorService } from 'src/app/services/doctor.service';

@Component({
    selector: 'app-list-upcoming',
    templateUrl: './list-upcoming.component.html',
    styleUrls: ['./list-upcoming.component.scss'],
    standalone: false,
})
export class ListUpcomingComponent implements OnInit {
    @Input() public rNumbs: IRnumbList[] = [];

    @Output() public onDateGet = new EventEmitter<ICalendarDateActive[]>();
    @Input()
    public set selectDate(value: string) {
        this._selectDate = value;
        this.setFilterDate(this._selectDate);
    }

    public _selectDate: string = ''; // выбранная дата
    public _rNumbList: IRnumbList[] = [];
    public rNumbList: IRnumbList[] = [];
    @Input()
    public set selectedDate(value: string) {
        this._selectedDate = value;
        this.setFilterDate(this._selectedDate);
        this.selectedDateInCalenadr = formatUiDate(
            parseDateTime(value, 'yyyy-MM-dd'),
        );
    }
    public get selectedDate() {
        return this._selectedDate;
    }
    public _selectedDate: string = ''; // выбранная дата

    public loadingRnumbList = false; // Загрузка талонов
    public selectedDateInCalenadr: string = '';
    public isLoading = true;
    public loadedPages = 1;
    public viewPage = 1;
    public countOfPages = 1;
    public rnumbPages: IRnumbList[][] = [];
    public rnumbListLength: number = 0; // Количество записей
    public loadingMoreContent = false;
    public isMobile: boolean = false;
    public rnumbList: IRnumbList[] = [];
    public filteredRnumbList: IRnumbList[] = [];
    public closeResult: string = '';
    public modalReference!: NgbModalRef;
    public uploadFilesGroup: IRnumbList[] = [];
    public mandatoryGroup: IRnumbList[] = [];
    public othersGroup: IRnumbList[] = [];

    private handleResize = () => {
        this.isMobile = window.innerWidth <= 767;
    };

    public constructor(
        private rs: RnumbService,
        private dialog: MatDialog,
        private router: Router,
        private doctorInfoService: DoctorService,
    ) {}

    public ngOnInit(): void {
        this.loadingRnumbList = true;
        this.getRnumbList().then(() => {
            this.isLoading = false;
        });
        this.isMobile = window.innerWidth <= 767;
        window.addEventListener('resize', this.handleResize);
    }

    public ngOnDestroy(): void {
        window.removeEventListener('resize', this.handleResize);
    }

    //бут модалка для теле мои посещения
    public open(e: Event, content: any) {
        e.stopPropagation();

        const dialogRef = this.dialog.open(content, {
            width: this.isMobile ? '90%' : '',
            // data: {},
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.closeResult = `Closed with: ${result}`;
            }
        });
    }

    public getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    public JoinAndClose() {
        // this.modalReference.close();
        this.dialog.closeAll();
    }

    public async getRnumbList() {
        let dt: ICalendarDateActive[] = [];
        this.rnumbList = [];
        this.filteredRnumbList = [];
        this.loadingRnumbList = true;

        try {
            const res = await lastValueFrom(this.rs.getRnumbList());
            this.rnumbList = res;

            const selectedAppointmentId = sessionStorage.getItem(
                'selectedAppointmentId',
            );
            if (selectedAppointmentId) {
                const appointment = this.rnumbList.find(
                    (r) => r.rnumbId === parseInt(selectedAppointmentId),
                );
                if (appointment) {
                    setTimeout(() => {
                        this.openTalon(appointment);
                        sessionStorage.removeItem('selectedAppointmentId');
                    }, 500);
                } else {
                    sessionStorage.removeItem('selectedAppointmentId');
                }
            }

            // Форматируем даты
            this.rnumbList.forEach((item) => {
                item.beginDate = strToDate(item.datBgn);
                item.endDate = strToDate(item.datEnd);
                dt.push({
                    date: getDateKey(item.beginDate),
                });
            });

            // Сортировка по времени (от ближайших к далёким)
            this.rnumbList.sort((a, b) => {
                return (
                    (a.beginDate?.getTime() || 0) -
                    (b.beginDate?.getTime() || 0)
                );
            });

            // Группируем по логике:
            // - uploadFilesGroup: нужно прикрепить файлы (is_upload_files=1, is_file_attached != 1)
            // - othersGroup: всё остальное (включая is_file_attached=1, form_result_id, и просто обычные)
            //  item.form_result_id && item.is_exists === 0;

            this.uploadFilesGroup = [];
            this.othersGroup = [];

            this.rnumbList.forEach((item) => {
                // Если нужно прикрепить файлы И файлы НЕ прикреплены
                if (
                    (item.isUploadFiles === 1 &&
                        (!item.isFileAttached || item.isFileAttached !== 1)) ||
                    (item.formResultId && item.isExists === 0)
                ) {
                    this.uploadFilesGroup.push(item);
                } else {
                    this.othersGroup.push(item);
                }
            });

            // Объединяем, сохраняя порядок
            this.filteredRnumbList = [
                ...this.uploadFilesGroup,
                ...this.othersGroup,
            ];

            this.rnumbPages = [this.filteredRnumbList];
            this.onDateGet.emit(dt);
        } catch (error) {
            console.error('Ошибка загрузки талонов', error);
            dt.push({ date: getDateKey(new Date()) });
            this.onDateGet.emit(dt);
        } finally {
            this.loadingRnumbList = false;

            const firstPage = this.rnumbPages[0];
            if (Array.isArray(firstPage) && firstPage.length === 0) {
                this.rnumbPages = [];
                this.countOfPages = 0;
            }
        }
    }
    private _groupedItems: { title: string; items: IRnumbList[] }[] = [];

    public get groupedItems(): { title: string; items: IRnumbList[] }[] {
        const result: { title: string; items: IRnumbList[] }[] = [];

        const hasUploadGroup = this.uploadFilesGroup.length > 0;
        const hasOthersGroup = this.othersGroup.length > 0;

        if (hasUploadGroup) {
            result.push({
                title: 'Дополните посещения',
                items: this.uploadFilesGroup,
            });
        }

        if (hasOthersGroup) {
            result.push({
                title: hasUploadGroup ? 'Все посещения' : '',
                items: this.othersGroup,
            });
        }

        if (JSON.stringify(result) !== JSON.stringify(this._groupedItems)) {
            this._groupedItems = result;
        }

        return this._groupedItems;
    }

    public getGroupTitle() {
        if (this.uploadFilesGroup.length > 0) {
            return 'Прикрепите файлы';
        }

        if (this.mandatoryGroup.length > 0) {
            return 'Заполните анкету';
        } else {
            return;
        }
    }
    public getPriority(item: IRnumbList): number {
        if (this.isMobile && item.isUploadFiles === 1) {
            return 0;
        } else if (item.formResultId) {
            return 1;
        } else {
            return 2; // Default for others
        }
    }

    public setActionsTitle(item: IRnumbList): string {
        if (!this.isMobile) return '';
        if (this.isMobile && item.isUploadFiles === 1) {
            return 'Прикрепите файлы';
        } else if (item.formResultId) {
            return 'Заполните анкету';
        } else {
            return 'За все время';
        }
    }

    public getTime(dt: Date | undefined): string {
        if (dt && toDateTime(dt).hour > 3) {
            return formatTime(dt);
        } else {
            return '';
        }
    }

    public getDate(dt: Date | undefined): string {
        if (dt) {
            return formatUiDate(dt);
        } else {
            return '';
        }
    }

    public getTekDay(dt: Date | undefined): string {
        if (dt) {
            return formatUiDate(dt);
        } else {
            return '';
        }
    }

    public getNameDay(dt: Date | undefined): string {
        if (dt) {
            let day = '';
            const d = DateTime.local()
                .startOf('day')
                .diff(toDateTime(dt).startOf('day'), 'days').days;
            switch (d) {
                case 0: {
                    day = 'Сегодня';
                    break;
                }
                case 1: {
                    day = 'Завтра';
                    break;
                }
                default: {
                    day = getNameDay(dt);
                    break;
                }
            }
            return day;
        } else {
            return '';
        }
    }

    public setFilterDate(dt: string) {
        if (dt.length == 0) {
            this.filteredRnumbList = this.rnumbList;
        } else {
            this.filteredRnumbList = this.rnumbList.filter(
                (item) => formatApiDate(item.beginDate) === dt,
            );
        }
    }

    public returnAllEvents() {
        this.getRnumbList();
    }

    public openTalon(talon: IRnumbList, files?: FileList) {
        let dt: ITalonModal = {
            rnumbId: talon.rnumbId,
            paramCansel: true,
            withUploadFiles: Boolean(Number(talon.isUploadFiles)),
            tag: talon.tag,
            link_id: talon.linkId,
            visit_id: talon.visitId || undefined,
            is_exist: talon.isExists || undefined,
            form_result_id: talon.formResultId || undefined,
        };
        const result = lastValueFrom(
            this.doctorInfoService.getDocAboutInfo(talon.doctorId),
        );

        result.then((res) => {
            dt.infoDoc = res;
        });

        if (files) dt.files = files;

        let dialogRefOptions = {
            width: 'auto',
            height: 'auto',
            maxWidth: 'auto',
            minWidth: 'auto',
            closeOnNavigation: true,
            data: dt,
        };

        // Check screen width and adjust dialog options if needed
        if (window.matchMedia('(max-width: 768px)').matches) {
            dialogRefOptions.width = '92vw';
            // dialogRefOptions.height = 'calc(100% - 2vh)';
            dialogRefOptions.maxWidth = '100vw';
            dialogRefOptions.minWidth = '90vw';
        }

        const dialogRef = this.dialog.open(
            NewTalonComponentMobile,
            dialogRefOptions,
        );

        dialogRef.afterClosed().subscribe((result) => {
            // Отмена номерка
            if (result && result.rnumbID && result.cancelRes) {
                this.getRnumbList(); // Обновляем все
            }
        });
    }

    public stopPropagation(e: Event) {
        e.stopPropagation();
    }

    // открыть в новом окне ТЕЛЕМЕДИЦИНУ
    public goToTelemed(rec: IRnumbList, e: MouseEvent) {
        e.stopPropagation();

        if (rec.urlTelemed && rec.urlTelemed.length > 5) {
            window.open(rec.urlTelemed, '_blank');
        }
    }

    public onVisitProtocolClick(talon: IRnumbList, e: MouseEvent) {
        e.stopPropagation();

        this.router.navigate([
            `home/visit-protocol/${talon.visitId}/${talon.formResultId}`,
        ]);
    }

    public onChangeInputUpload(event: Event, talon: IRnumbList) {
        const target = event.target as HTMLInputElement;
        const files = target.files;
        // console.log(target, files);
        if (!files) {
            console.log('NO FILES IN INPUT');
            return;
        }
        // console.log(files);
        this.openTalon(talon, files);
        target.value = '';
    }
}
